import React, { useState } from 'react';
import { MdRequestQuote } from 'react-icons/md';

import { useFormikContext } from 'formik';

import SettingsOption from '../SettingsOption';
import TaxModal from './TaxModal';

const TaxSettings = () => {
  const { values, setFieldValue } = useFormikContext<any>();

  const [showTaxModal, setShowTaxModal] = useState(false);

  const toggleTaxModal = () => {
    setShowTaxModal((showTaxModal) => !showTaxModal);
  };

  const onSave = (tax?: {
    taxId: string;
    name: string;
    ratePercent: number;
  }) => {
    setFieldValue('pricing.tax', tax || null);
  };

  return (
    <>
      <SettingsOption
        icon={<MdRequestQuote size={20} />}
        title="Collect tax on tickets"
        actionLabel="Add tax"
        value={values?.pricing?.tax?.taxId}
        onClick={toggleTaxModal}
        tooltipMessage="Only registered businesses can charge taxes. Consult a tax professional to better understand your tax obligations."
      />

      {showTaxModal && (
        <TaxModal
          onClose={toggleTaxModal}
          onSave={onSave}
          initialValues={values?.pricing?.tax}
        />
      )}
    </>
  );
};

export default TaxSettings;
